.button {
  width: spacing(48);
  height: spacing(48);
}

.button + .button {
  margin-left: spacing(8);
}
